"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("./ButtonGroup.less");

var ButtonGroup = function ButtonGroup(_ref) {
  var children = _ref.children,
      _ref$block = _ref.block,
      block = _ref$block === void 0 ? false : _ref$block;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "primitive-button-group ".concat(block ? 'block' : '')
  }, children);
};

var _default = ButtonGroup;
exports.default = _default;